// extracted by mini-css-extract-plugin
export default {"user-show":"styles_user-show__oVmJH","user-name":"styles_user-name__R1ulv","user-email":"styles_user-email__lhK6I"};